<template>
  <div class="tw-flex tw-gap-3 tw-items-center tw-min-h-5">
    <div>
      <div
        class="tw-text-xs tw-cursor-pointer tw-relative tw-w-5 tw-mt-0.5"
        :class="{
          '!tw-border-gray-400 !tw-text-gray-400 !tw-cursor-default': disabled,
        }"
        @click="onClick"
      >
        <IconButton
          :showBackgroundHover="false"
          class="tw-absolute tw-top-0 tw-left-0 tw-w-10 tw-h-10 -tw-mt-5 -tw-ml-2 !tw-p-2 tw-flex tw-items-center tw-justify-center"
        >
          <div
            class="tw-h-4.5 tw-w-4.5 tw-border-2 tw-border-solid tw-border-gray-900 tw-rounded tw-flex tw-items-center tw-justify-center"
          >
            <div v-if="isSelected && !isIndeterminate">
              <img :src="CheckIcon" class="tw-w-4" />
            </div>
            <div v-if="isIndeterminate">
              <div class="tw-w-2 tw-bg-black tw-h-0.5"></div>
            </div>
          </div>
        </IconButton>
      </div>
    </div>
    <div
      v-if="label"
      class="tw-cursor-pointer tw-flex tw-items-center tw-gap-1"
      @click="onClick"
    >
      <slot name="prepend"></slot>{{ label }}
    </div>
  </div>
</template>
<script>
import IconButton from '@/components/v3/base/IconButton';
import CheckIcon from '@/assets/icons/checked-icon.svg';

export default {
  components: {
    IconButton,
  },

  props: {
    value: {
      type: [String, Number, Boolean, Array],
      default: () => [],
    },

    val: {
      type: [String, Number, Boolean],
      default: '',
    },

    isIndeterminate: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: '',
    },

    readonly: Boolean,
  },

  data() {
    return {
      CheckIcon,
    };
  },

  computed: {
    isSelected() {
      if (Array.isArray(this.value)) {
        return this.value && this.value.includes(this.val);
      }
      return this.value === this.val;
    },
  },

  methods: {
    onClick() {
      if (this.disabled || this.readonly) return;
      if (Array.isArray(this.value)) {
        let val = this.value || [];
        if (this.value && this.value.includes(this.val)) {
          val = this.value.filter((item) => item !== this.val);
        } else {
          val.push(this.val);
        }

        this.$emit('input', val);
      } else {
        if (typeof this.value === 'boolean') {
          this.$emit('input', !this.value);
          return;
        }
        this.$emit('input', this.val);
      }
    },
  },
};
</script>
